import { jsPDF } from 'jspdf';

import { CuripodElement } from '../../components/SlideComponents/slateUtil';
import { LINE_HEIGHT_FACTOR } from './constants';
import renderBulletList from './renderBulletList';
import renderNumberedList from './renderNumberedList';
import renderParagraph from './renderParagraph';

export type FontStyle = 'Normal' | 'Bold' | 'Italic' | 'BoldItalic';
export type Alignment = 'left' | 'right' | 'center';

type RenderTextElementProps = {
  pdf: jsPDF;
  x: number;
  y: number;
  width: number;
  textElements: CuripodElement[];
  defaultAlignment?: Alignment;
  scale?: number;
};

const renderTextElement = async ({
  pdf,
  x,
  y,
  width,
  textElements,
  scale = 1,
}: RenderTextElementProps) => {
  let currentY = y;
  for (const eachTextElement of textElements) {
    if (!eachTextElement?.size) continue;
    pdf.saveGraphicsState();
    const pdfFontSize = eachTextElement.size * scale;
    pdf.setLineHeightFactor(LINE_HEIGHT_FACTOR);
    pdf.setFontSize(pdfFontSize);
    if (eachTextElement.type === 'paragraph') {
      const { updatedY } = await renderParagraph({
        pdf,
        x,
        y: currentY,
        width,
        paraElement: eachTextElement,
        scale,
      });
      currentY = updatedY;
    } else if (eachTextElement.type === 'bulleted-list') {
      const { updatedY } = await renderBulletList({
        pdf,
        x,
        y: currentY,
        width,
        bulletListElement: eachTextElement,
        scale,
      });
      currentY = updatedY;
    } else if (eachTextElement.type === 'numbered-list') {
      const { updatedY } = await renderNumberedList({
        pdf,
        x,
        y: currentY,
        width,
        numberedListElement: eachTextElement,
        scale,
      });
      currentY = updatedY;
    } else {
      //console.debug(`Unknown element type - "${eachTextElement.type}"`);
    }
    pdf.restoreGraphicsState();
  }
};

export default renderTextElement;
